"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Girl = function Girl(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    height: "40",
    width: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 8.25,17.189V18c0,2.071,1.679,3.75,3.75,3.75s3.75-1.679,3.75-3.75v-0.811 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6.754,8.808 c0.553,0.371,1.205,0.568,1.871,0.567C10.188,9.292,11.534,8.245,12,6.75c0.466,1.495,1.812,2.542,3.375,2.625 c0.666,0.001,1.318-0.196,1.871-0.567 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 12,3.75c2.899,0,5.25,2.351,5.25,5.25s-2.351,5.25-5.25,5.25S6.75,11.899,6.75,9 S9.101,3.75,12,3.75z ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 21.809,23.25c-2.069-5.417-8.138-8.132-13.555-6.063c-2.792,1.066-4.997,3.271-6.063,6.063 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 16.531,11.653 c1.574,1.182,3.352,2.063,5.246,2.6c-0.805-3.196-1.307-6.46-1.5-9.75c-0.001-2.071-1.68-3.749-3.751-3.749 C14.719,0.755,13.17,2.044,12.84,3.82",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Girl.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Girl.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Girl;